<template>
  <div>
    <div class="scale">
      <a-button  :size="$globalSize"  icon="plus"  @click="scale += 10" :disabled="scale >= 150" shape="circle"></a-button>
      <span>{{ scale }}%</span>
      <a-button  :size="$globalSize"  icon="minus"  @click="scale -= 10" :disabled="scale <= 40" shape="circle"></a-button>
      <!--      <a-button  :size="$globalSize"  @click="validate">校验流程</a-button>-->
    </div>
    <div class="design" :style="'transform: scale(' + scale / 100 + ');'">
      <process-tree ref="process-tree" @selectedNode="nodeSelected" />
    </div>
    <a-drawer :title="selectedNode.name" :visible="showConfig" :closable="true" @close="onClose"
      :modal-append-to-body="false" :width="600" direction="rtl" :modal="false" destroy-on-close>
      <div slot="title">
        <a-input :size="$globalSize" v-model="selectedNode.name" size="medium" v-show="showInput" style="width: 300px"
          @blur="showInput = false"></a-input>
        <a-link v-show="!showInput" @click="showInput = true" style="font-size: medium">
          <a-icon type="edit" style="margin-right: 10px"></a-icon>
          {{ selectedNode.name }}
        </a-link>
      </div>
      <div class="node-config-content">
        <node-config @onClose="onClose"/>
      </div>
    </a-drawer>

    <div :style="{
      position: 'absolute',
      right: 0,
      bottom: 0,
      width: '100%',
      borderTop: '1px solid #e9e9e9',
      padding: '10px 16px',
      background: '#fff',
      textAlign: 'right',
      zIndex: 1,
    }">
      <a-button  :size="$globalSize"  type="primary" @click="onSubmitOk">
        确认提交
      </a-button>
    </div>
  </div>
</template>

<script>
import ProcessTree from './process/ProcessTree.vue'
import NodeConfig from '../../common/process/config/NodeConfig'
import workflow from "@/interface/pages/workflow/workflow";
export default {
  name: "ProcessDesign",
  components: { ProcessTree, NodeConfig },
  inject:["schedule_id"],
  data() {
    return {
      scale: 100,
      selected: {},
      showInput: false,
      showConfig: false
    }
  },
  computed: {
    selectedNode() {
      return this.$store.state.selectedNode
    }
  },
  mounted() {

  },
  methods: {
    validate() {
      return this.$refs["process-tree"].validateProcess()
    },
    nodeSelected(node) {
      this.showConfig = true
    },
    onClose() {
      this.showConfig = false;
    },
    onSubmitOk() {
      this.saveWorkFlow()
    },
    async saveWorkFlow() {

    
      var schedule_id = this.schedule_id();
      var params ={schedule_id:schedule_id}

      workflow.saveWorkFlow(this, { params:params,data: this.$store.state.design.process }).then(
        function (resp) {
          let res = resp.data;
          if (res.code == '200') {
            this.$message.success(res.message);
          } else {
            this.$message.error(res.message);
          }
        }.bind(this)
      ).catch(reason => {
        console.log(reason);
      })
    },
  },
  watch: {
    /*selectedNode:{
      deep: true,
      handler(node){
        console.log("更新")
        this.$refs["process-tree"].nodeDomUpdate(node)
      }
    }*/
  }
}
</script>

<style lang="less" scoped>
.design {
  margin-top: 100px;
  display: flex;
  transform-origin: 50% 0px 0px;
}

.scale {
  z-index: 999;
  position: absolute;
  top: 30px;
  right: 40px;

  span {
    margin: 0 10px;
    font-size: 15px;
    color: #7a7a7a;
    width: 50px;
  }
}

.node-config-content {
  padding: 0 20px 20px;
}

::v-deep .el-drawer__body {
  overflow-y: auto;
}
</style>
